document.addEventListener("DOMContentLoaded", function () {
  function updateSalePrices() {
    // Sélectionne tous les éléments contenant un prix en solde
    document.querySelectorAll('.product-card__price--on-sale sale-price strong').forEach(salePrice => {
      if (salePrice) {
        salePrice.style.color = 'red';
        salePrice.style.fontWeight = 'bold';
      }
    });
  }

  // Appliquer la modification immédiatement
  updateSalePrices();

  // Observer les changements du DOM si les produits sont chargés dynamiquement
  const observer = new MutationObserver(updateSalePrices);
  observer.observe(document.body, { childList: true, subtree: true });
});




